/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerUpdateChangeDecisionsMutationResponse, MultiDocumentAgentControllerUpdateChangeDecisionsPathParams } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerUpdateChangeDecisions";

function getMultiDocumentAgentControllerUpdateChangeDecisionsUrl(requestId: MultiDocumentAgentControllerUpdateChangeDecisionsPathParams["requestId"]) {
  const res = { method: 'PATCH', url: `/api/v1/multi-document-agent/requests/${requestId}/change-decisions` as const }  
  return res
}

/**
 * @description Finds the compliance or redlining thinking-step message by requestId and updates it with change decisions so they survive page refreshes.
 * @summary Persist accept/reject decisions for redlining changes on a request
 * {@link /api/v1/multi-document-agent/requests/:requestId/change-decisions}
 */
export async function multiDocumentAgentControllerUpdateChangeDecisions(requestId: MultiDocumentAgentControllerUpdateChangeDecisionsPathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<MultiDocumentAgentControllerUpdateChangeDecisionsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "PATCH", url : getMultiDocumentAgentControllerUpdateChangeDecisionsUrl(requestId).url.toString(), ... requestConfig })  
  return res.data
}